import Vue from 'vue';
import { mapGetters } from 'vuex';
import { guid } from '@/mixins/guid';
import { siteBuilder } from '@/mixins/site-builder';
import dropsLoader from '@/mixins/components/drops-loader';

export default Vue.component('site-cache', {
  template: require('./template.html'),
  name: 'site-cache',
  mixins: [guid, siteBuilder],
  computed: {
    ...mapGetters(['currentSite']),
    canGenerate() {
      return this.currentSite.cloudFront.id && this._published;
    },
  },
  components: {
    dropsLoader,
  },
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    async generateSite() {
      const notif = {
        id: this.guid(),
        type: 'success',
        message: 'Successfully cleared site cache!',
      };
      this.loading = true;
      try {
        await this.callBuilder({
          publish: 'site',
          site: {
            _id: this.currentSite._id,
          },
        });
      } catch (e) {
        const message = e.message || e;
        this.$log.error(message);
        notif.type = 'error';
        notif.message = message;
      } finally {
        this.loading = false;
        this.$store.dispatch('addNotification', notif);
      }
    },
  },
});



// WEBPACK FOOTER //
// ./src/global-view/editor/page/top-control-bar/global-options/cache/index.js